import { Component, OnInit } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { Router } from '@angular/router';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.css']
})
export class UnauthorizedComponent implements OnInit {

  constructor(protected keycloakAngular: KeycloakService,
              protected router: Router) { }

  ngOnInit() {  }

  connect() {
    this.keycloakAngular.logout()
  }
}



// WEBPACK FOOTER //
// ./src/app/errors/unauthorized/unauthorized.component.ts